/**
 * Shared formatting utilities for external content components.
 */
export const formatFileSize = (bytes) => {
    if (bytes < 1024)
        return `${bytes} B`;
    if (bytes < 1024 * 1024)
        return `${(bytes / 1024).toFixed(1)} KB`;
    if (bytes < 1024 * 1024 * 1024)
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    return `${parseFloat((bytes / (1024 * 1024 * 1024)).toFixed(2))} GB`;
};
export const formatDuration = (seconds) => {
    if (seconds === null || seconds <= 0)
        return "0:00";
    const totalSeconds = Math.round(seconds);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    if (hours > 0) {
        return `${hours}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    }
    return `${minutes}:${String(secs).padStart(2, "0")}`;
};
export const cleanDisplayName = (filename) => {
    const lastDot = filename.lastIndexOf(".");
    const name = lastDot > 0 ? filename.substring(0, lastDot) : filename;
    return name
        .replace(/_/g, " ")
        .replace(/\s{2,}/g, " ")
        .trim();
};
export const makeUniqueName = (name, existingNames) => {
    const lowerName = name.toLowerCase();
    if (!existingNames.has(lowerName))
        return name;
    let counter = 1;
    while (existingNames.has(`${name.toLowerCase()} (${counter})`)) {
        counter++;
    }
    return `${name} (${counter})`;
};
export const formatDurationCompact = (seconds) => {
    if (seconds === undefined || seconds <= 0)
        return "";
    const totalSeconds = Math.round(seconds);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    const parts = [];
    if (hours > 0)
        parts.push(`${hours}h`);
    if (minutes > 0 || hours > 0)
        parts.push(`${minutes}m`);
    parts.push(`${String(secs).padStart(2, "0")}s`);
    return parts.join(" ");
};
